import acc from "accounting"
import { Divider, Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../../../Icon"

const { Title, Text } = Typography

const FromBonuses = () => {
  const { t } = useTranslation()
  const commissions = useSelector((state) => state.referrals?.commissions)

  return (
    <Flex className="commission-div" vertical flex={1}>
      <Title level={5}>{t("From Bonuses")}</Title>
      <Text type="secondary">
        {t("See what you earn from all referred businesses and their total alerts.")}
      </Text>
      <Divider />
      <Flex vertical gap={12}>
        {commissions?.milestone_scheme &&
          Object.entries(commissions?.milestone_scheme).map(([key, value]) => {
            const isEarned = commissions?.earned_milestones.includes(+key)
            return (
              <Flex justify="space-between" align="center" key={key}>
                <Flex gap={12}>
                  <Icon
                    type={isEarned ? "unlockedlock" : "lock"}
                    style={{ fontSize: 20, color: "#A1A1AA" }}
                  />
                  <Text>
                    {acc.formatNumber(key, 0, ",")} {t("Alerts")}
                  </Text>
                </Flex>
                <Text type="secondary">
                  {`$${acc.formatNumber(value / 100, 0, ",")}`}
                </Text>
              </Flex>
            )
          })}
      </Flex>
    </Flex>
  )
}

export default FromBonuses
